import React, { useEffect, useState } from "react";
import {
  useGetCompanies,
  useGetCompanyVendorLocations,
  useGetCompanyLocations,
  useGetVendorCategories,
  useImporvendortLocations,
} from "../../../../backend/masters";
import Icon from "../../../common/Icon";
import { ACTIONS, EXCEL_FILE_REGEX, FILE_SIZE } from "../../../common/Constants";
import Table, {
  CellTmpl,
  DEFAULT_OPTIONS_PAYLOAD,
  DEFAULT_PAYLOAD,
  TitleTmpl,
  reactFormatter,
} from "../../../common/Table";
import { useQueryParams } from "raviger";
import { useRef } from "react";
import Select from "react-select";
import TableFilters from "../../../common/TableFilter";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "../../../../utils/constants";
import MastersLayout from "../MastersLayout";
import { GetMastersBreadcrumb } from "../Master.constants";
import { useExportVendorLocations } from "../../../../backend/exports";
import { download, downloadFileContent, getValue, preventDefault } from "../../../../utils/common";
import TableActions, { ActionButton } from "../../../common/TableActions";
import CompanyVendorLocationDetails from "./CompanyVendorLocationMappingDetails";
import CompanyVendorLocationsImportModal from "./CompanyVendorLocationsImportModel";
import Location from "../../../common/Location";
import BaseImportModal from "../../../common/BaseImportModal";
import { componentTypes } from "../../../common/FormRenderer";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";

function CompanyVendorLocationMappings() {
  const [breadcrumb] = useState(GetMastersBreadcrumb("Vendor mapping"));
  const [query] = useQueryParams();
  const [action, setAction] = useState(ACTIONS.NONE);
  const [parentCompany, setParentCompany] = useState<any>(null);
  const [associate_company, setAssociateCompany] = useState<any>(null);
  const [companyLocation, setCompanyLocation] = useState<any>(null);
  const [VendorLocation, setVendorLocation] = useState<any>(null);
  const [vendorCategory, setVendorCategory] = useState<any>(null);
  const [data, setData] = useState<any>();

  const [params, setParams] = useState<any>();

  const [filters, setFilters] = useState<any>();
  const filterRefTest: any = useRef();
  filterRefTest.current = filters;

  const [payload, setPayload] = useState<any>();

  const { companies: parentCompanies, isFetching: fetchingCompanies } =
    useGetCompanies({
      ...DEFAULT_OPTIONS_PAYLOAD,
      filters: [{ columnName: "isParent", value: "true" }],
    });
  const {
    companies: associateCompanies,
    isFetching: fetchingAssociateCompanies,
  } = useGetCompanies(
    {
      ...DEFAULT_OPTIONS_PAYLOAD,
      filters: {
        is_parent_eq: false,
        parent_company_id_eq: (parentCompany || {}).value
      }
    },
    Boolean((parentCompany || {}).value)
  );
  const { vendorCategories, isFetching: fetchingVendorCategories } =
    useGetVendorCategories({
      ...DEFAULT_PAYLOAD,
      sorts: ['vendor_category_name asc'],
    });

  const {
    locations,
    isFetching: fetchinglocation,
    refetch: locationRefetch,
  } = useGetCompanyLocations(
    {
      ...DEFAULT_PAYLOAD,
      filters: {
        company_id_eq: (associate_company && associate_company.value
              ? associate_company.value
              : "")
      },
      includes: ['location'],
      include: {
        location: {
          only: ['id','name','code']
        }
      }
    },
    Boolean(associate_company && payload)
  );
  const {
    vendorLocations,
    total,
    isFetching,
    refetch: vendorMappingRefetch,
  } = useGetCompanyVendorLocations(
    {
      ...payload,
      filters: {
        associate_company_id_eq: (associate_company ? associate_company.value : ""),
        location_id_eq: (companyLocation ? companyLocation.value : ""),
        vendor_category_id_eq: (vendorCategory ? vendorCategory.value : "")
      },
      includes: ['location'],
      include: {
        location: {
          only: ['id','name','code']
        }
      }
    },
    Boolean(associate_company && payload)
  );

  const { exportRecords, exporting } = useExportVendorLocations(
    (response: any) => {
      downloadFileContent({
        name: "CompanyVendorLocations.xlsx",
        type: response.headers["content-type"],
        content: response.data,
      });
    },
    () => {
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  );

  const buttons: ActionButton[] = [
    {
      label: "Add New",
      name: "addNew",
      icon: "plus",
      disabled: !associate_company,
      // privilege: USER_PRIVILEGES.ADD_LOCATION_MAPPING,
      action: () => setAction(ACTIONS.ADD),
    },
    {
      label: "Export",
      name: "export",
      icon: "download",
      //disabled: !total,
      // privilege: USER_PRIVILEGES.EXPORT_LOCATION_MAPPINGS,
      action: handleExport,
    },
    {
      label: "Import",
      name: "import",
      disabled: !associate_company,
      icon: "upload",
      // privilege: USER_PRIVILEGES.ADD_LOCATION_MAPPING,
      action: () => setAction(ACTIONS.IMPORT),
    },
  ];

  const filterConfig = [
    {
      label: "Company",
      name: "parentCompanyId",
      options: (parentCompanies || []).map((x: any) => {
        return { value: x.id, label: x.name };
      }),
      hideAll: true,
      value: parentCompany,
    },
    // {
    //   label: "Associate Company",
    //   name: "associate_company_id",
    //   options: (associateCompanies || []).map((x: any) => {
    //     return { value: x.id, label: x.name };
    //   }),
    //   hideAll: true,
    //   value: associate_company,
    // },
    // {
    //   label: "Location4",
    //   name: "location_id",
    //   options: (locations || []).map((x: any) => {
    //     return { value: x.id, label: x.location.name };
    //   }),
    //   hideAll: true,
    //   value: companyLocation,
    // },
    // {
    //   label: "Vendor Category",
    //   name: "vendorCategoriesId",
    //   options: (vendorCategories || []).map((x: any) => {
    //     return { value: x.id, label: x.vendorCategoryName };
    //   }),
    //   hideAll: true,
    //   value: vendorCategory,
    // },
  ];

  const filterAssocioConfig = [
    {
      label: "Associate Company",
      name: "associate_company_id",
      options: (associateCompanies || []).map((x: any) => {
        return { value: x.id, label: x.name };
      }),
      hideAll: true,
      value: associate_company,
    },
  ];

  const filterVendorConfig = [
    {
      label: "Vendor Category",
      name: "vendorCategoriesId",
      options: (vendorCategories || []).map((x: any) => {
        return { value: x.id, label: x.vendorCategoryName };
      }),
      hideAll: true,
      value: vendorCategory,
    }
  ];

  const filterLocationConfig = [
    {
      label: "Location",
      name: "location_id",
      options: (locations || []).map((x: any) => {
        return { value: x.id, label: x.location.name };
      }),
      hideAll: true,
      value: companyLocation,
    },
  ];

  function submitCallback() {
    setAction(ACTIONS.NONE);
    vendorMappingRefetch();
  }

  function ActionColumnElements({ cell }: any) {
    const row = cell.getData();
    return (
      <div className="d-flex flex-row align-items-center position-relative h-100">
        <Icon
          className="mx-2"
          type="button"
          name={"pencil"}
          text={"Edit"}
          data={row}
          action={(event: any) => {
            setVendorLocation(row);
            setAction(ACTIONS.EDIT);
          }}
        />
        <Icon
          className="mx-2"
          type="button"
          name={"eye"}
          text={"View"}
          data={row}
          action={(event: any) => {
            setVendorLocation(row);
            setAction(ACTIONS.VIEW);
          }}
        />
      </div>
    );
  }

  const columns = [
    {
      title: "Vendor",
      field: "vendorRegistartion.vendorName",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Company",
      field: "company.name",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Associate Company",
      field: "associate_company.name",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Location",
      field: "location.name",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Category",
      field: "vendorCategories.vendorCategoryName",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Actions",
      hozAlign: "center",
      width: 160,
      headerSort: false,
      formatter: reactFormatter(<ActionColumnElements />),
    },
  ];

  const [tableConfig] = useState({
    paginationMode: "remote",
    ajaxRequestFunc,
    columns,
    rowHeight: 54,
    selectable: false,
    paginate: true,
    initialSort: ['location_name asc'],
  });

  function formatApiResponse(params: any, list: any[], totalRecords: number) {
    const { pagination } = params || {};
    const { per, page } = pagination || {};
    const tdata = {
      data: list,
      total: totalRecords,
      last_page: Math.ceil(totalRecords / (per || 1)) || 1,
      page: page || 1,
    };
    setData(tdata);
    return tdata;
  }

  function ajaxRequestFunc(url: any, config: any, params: any) {
    const { field, dir } = (params.sort || [])[0] || {};
    const columnName = field || "location";
    const order = dir || "asc";
    const _params = {
      per: params.size,
      page: params.page,
      sorts: [`${columnName} asc`]
    };
    setParams(_params);
    setPayload({ ...DEFAULT_PAYLOAD, ...filterRefTest.current, ..._params });
    return Promise.resolve(formatApiResponse(params, vendorLocations, total));
  }

  function onFilterChange(e: any) {
    setFilters(e);
    if(e.filters.associate_company_id){
      setCompanyLocation([]);
      // setFilters(e);
    }
  }

  function handlePageNav(_pagination: any) {
    const _params = { ...params };
    _params.pagination = _pagination;
    setParams({ ..._params });
    setPayload({ ...payload, ..._params });
  }

  function handleExport() {
    // if (total > 0) {
    console.log(associate_company)
    console.log(companyLocation)
    console.log(vendorCategory)
      const filters:any = {}
      if (associate_company) {
        filters['associate_company_id_eq'] = associate_company.value
      }
            // if (companyLocation) {
            //   filters.push({
            //     columnName: 'locationid',
            //     value: companyLocation.value
            //   })
            // }
            // if (vendorCategory) {
            //   filters.push({
            //     columnName: 'vendorcategoriesid',
            //     value: vendorCategory.value
            //   })
            // }
            const payload: any = {
                    search: '',
                    filters: filters,
                    sorts: ['location_name asc'],
                    "includeCentral": true
                  }
                  console.log(payload);

      exportRecords({ ...payload, pagination: null });
    // }
  }

 

  useEffect(() => {
    if (
      query &&
      (query.parentCompany ||
        query.associate_company ||
        query.location ||
        query.vendorCategory)
    ) {
      setParentCompany({ value: query.parentCompany });
      setAssociateCompany({ value: query.associate_company });
      setVendorCategory(query.vendorCategory);
      setCompanyLocation(() => {
        const location = locations.find((s: any) => s.name === query.location);
        return {
          label: location.location.name,
          value: location.location_id,
        };
      });
    }
  }, [query]);

  useEffect(() => {
    if (filters) {
      // alert("hitted")     
      const { filters: _filters, search } = filters;
      setData(formatApiResponse(params, [], 0));
      const _associate_company_id = _filters['associate_company_id_eq'];
      const _parentCompanyId = _filters['parent_company_id_eq'];
      const TestLocationId = _filters['location_id_eq'];
      const _vendorCategoreisId = _filters['vendor_category_id_eq'];
      if (_parentCompanyId) {
        const _parentCompany = parentCompanies.find(
          (x: any) => x.id === _parentCompanyId
        );
        setParentCompany({
          value: _parentCompany.id,
          label: _parentCompany.name,
          code: _parentCompany.code,
        });
        if ((parentCompany || {}).value !== _parentCompanyId) {
          setAssociateCompany(null);
          setCompanyLocation(null);
          setPayload(null);
          return;
        }
      }

      if (_associate_company_id) {
        const _associate_company = associateCompanies.find(
          (x: any) => x.id === _associate_company_id
        );
        if (_associate_company) {
          setAssociateCompany({
            value: _associate_company.id,
            label: _associate_company.name,
            code: _associate_company.code,
          });
          
          const _x = {
            filters: {
              associate_company_id_eq: _associate_company_id
            },
            search,
          };
          setPayload({ ...DEFAULT_PAYLOAD, ...params, ..._x });
          return;
        }
      }
      if (_vendorCategoreisId) {
        const _vendorCategory = vendorCategories.find(
          (x: any) => x.id === _vendorCategoreisId
        );
        if (_vendorCategory) {
          setVendorCategory({
            value: _vendorCategory.id,
            label: _vendorCategory.vendorCategoryName,
          });
          const _x = {
            filters: {
              vendor_category_id_eq: _vendorCategoreisId
            },
            search,
          };
          setPayload({ ...DEFAULT_PAYLOAD, ...params, ..._x });
          return;
        }
      }
      if (TestLocationId) {
        //alert("hitted TestLocationId" )
        const _location = locations.find((x: any) => x.id === TestLocationId);
        if (_location) {
          setCompanyLocation({
            value: _location.location_id,
            label: _location.location.name,
          });
          //debugger
          const _x = {
            filters: {
              location_id_eq: TestLocationId
            },
            search,
          };
          setPayload({ ...DEFAULT_PAYLOAD, ...params, ..._x });
          return;
        }
      }
      setPayload({ ...payload, search });
    }
  }, [filters]);

  useEffect(() => {
    if (!isFetching && payload) {
      setData(formatApiResponse(params, vendorLocations, total));
    }
  }, [isFetching]);

  useEffect(() => {
    if (!fetchingCompanies && parentCompanies) {
      const _parentCompany = (parentCompanies || [])[0] || {};
      setParentCompany({
        value: _parentCompany.id,
        label: _parentCompany.name,
        code: _parentCompany.code,
      });
    }
  }, [fetchingCompanies]);

  useEffect(() => {
    if (!fetchingAssociateCompanies && associateCompanies) {
      const _associate_company = (associateCompanies || [])[0];
      if (_associate_company) {
        setAssociateCompany({
          value: _associate_company.id,
          label: _associate_company.name,
          code: _associate_company.code,
        });
        const { search } = filterRefTest.current || { search: "" };
        setFilters({
          filters: {
            parent_company_id_eq: (parentCompany || {}).value,
            associate_company_id_eq: _associate_company.id
          },
          search,
        });
      }
    }
  }, [fetchingAssociateCompanies]);

  useEffect(() => {
    if (!fetchingVendorCategories && vendorCategories) {
      const _vendorCategory = (vendorCategories || [])[0];
      if (_vendorCategory) {
        setVendorCategory({
          value: _vendorCategory.id,
          label: _vendorCategory.vendorCategoryName,
        });
        const { search } = filterRefTest.current || { search: "" };
        setFilters({
          filters: {
            parent_company_id_eq: (parentCompany || {}).value,
            associate_company_id_eq: (associate_company || {}).value,
            vendor_category_id_eq: _vendorCategory.id
          },
          search,
        });
      }
    }
  }, [fetchingVendorCategories]);

  useEffect(() => {
    if (!fetchinglocation && locations && !companyLocation) {
      const _location = (locations || [])[0];
      if (_location) {
        setCompanyLocation({
          label: _location.location.name,
          value: _location.location_id,
        });
        const { search } = filterRefTest.current || { search: "" };
        setFilters({
          filters: {
            parent_company_id_eq: (parentCompany || {}).value,
            associate_company_id_eq: (associate_company || {}).value,
            vendor_category_id_eq: (vendorCategory || {}).value,
            location_id_eq: _location.id
          },
          search,
        });
      }
    }
  }, [companyLocation, fetchinglocation]);
  useEffect(() => {
    locationRefetch();
  }, [associate_company]);

  useEffect(() => {
    console.log("loca:", companyLocation);
  }, [companyLocation]);

  const importSchema = {
      fields: [
          {
              component: componentTypes.PLAIN_TEXT,
              label: 'Company',
              content: getValue(parentCompany, 'label'),
              name: 'company'
          },
          {
              component: componentTypes.PLAIN_TEXT,
              label: 'Associate Company',
              content: getValue(associate_company, 'label'),
              name: 'associate_company'
          },
          {
              component: componentTypes.PLAIN_TEXT,
              label: 'Location',
              content: getValue(location, 'label'),
              name: 'Location'
          },
          
          {
              component: componentTypes.FILE_UPLOAD,
              label: 'Upload File',
              name: 'file',
              type: 'file',
              validate: [
                  { type: validatorTypes.REQUIRED },
                  { type: 'file-type', regex: EXCEL_FILE_REGEX },
                  { type: 'file-size', maxSize: 10 * FILE_SIZE.MB }
              ],
              description: <a href="/" onClick={downloadSample}>Dowload Sample Vendor Locations</a>
          },
      ],
  };

  function downloadSample(e: any) {
      preventDefault(e);
      //download('Sample Locations.xlsx', 'https://mafoi.s3.ap-south-1.amazonaws.com/bulkuploadtemplates/LocationBulkUploadTemplate.xlsx ')
      download('Sample Vendor Locations.xlsx', 'https://mafoi.s3.ap-south-1.amazonaws.com/bulkuploadtemplates/BulkVendorLocationMappingTemplate.xlsx')
  }

  return (
    <>
      <MastersLayout title="Vendor Location Mapping" breadcrumbs={breadcrumb}>
        <div className="d-flex flex-column mx-0">
          <div className="card shadow d-flex flex-row justify-content-center m-3 p-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-end">
                <TableFilters
                  filterConfig={filterConfig}
                  // search={true}
                  onFilterChange={onFilterChange}
                // placeholder={"Search for Location Code/Name"}
                />
                <TableFilters
                  filterConfig={filterAssocioConfig}
                  // search={true}
                  onFilterChange={onFilterChange}
                // placeholder={"Search for Location Code/Name"}
                />
                <TableFilters
                  filterConfig={filterLocationConfig}
                  //search={true}
                  onFilterChange={onFilterChange}
                // placeholder={"Search for Location Code/Name"}
                />
                <TableFilters
                  filterConfig={filterVendorConfig}
                 // search={true}
                  onFilterChange={onFilterChange}
                  //placeholder={"Search for Location Code/Name"}
                />

                <TableActions buttons={buttons} />
              </div>
              <div className="d-flex justify-content-between align-items-end">

                {/* <div className="d-flex flex-column me-3" key={filter.name}>
                  <label className="filter-label"><small>{filter.label}</small></label>
                  <Select options={filter.hideAll ? [...filter.options] : [DEFAULT_OPTION, ...filter.options]}
                    defaultValue={filter.hideAll ? filter.defaultValue : DEFAULT_OPTION} value={filter.value}
                    onChange={(e: any) => handleFilterChange(filter, e)} className="select-control"
                  />
                </div> */}
              </div>
            </div>
          </div>
          <Table
            data={data}
            options={tableConfig}
            isLoading={isFetching}
            onPageNav={handlePageNav}
          />
        </div>
      </MastersLayout>

      {[ACTIONS.ADD, ACTIONS.EDIT, ACTIONS.VIEW].includes(action) && (
        <CompanyVendorLocationDetails
          action={action}
          parentCompany={parentCompany}
          associate_company={associate_company}
          vendorCategory={vendorCategory}
          location={companyLocation}
          data={VendorLocation}
          onClose={() => {
            setAction(ACTIONS.NONE);
            setVendorLocation(null);
          }}
          onSubmit={submitCallback}
        />
      )}

      {/* {action === ACTIONS.IMPORT && (
        <CompanyVendorLocationsImportModal
          company={parentCompany}
          associate_company={associate_company}
          location={companyLocation}
          onSubmit={vendorMappingRefetch}
          onClose={() => setAction(ACTIONS.NONE)}
        />
      )} */}
      {
          action === ACTIONS.IMPORT && <BaseImportModal onClose={() => setAction(ACTIONS.NONE)} importSchema={importSchema} importFunction={useImporvendortLocations} title="Import Company Vendor Locations" />
      }
    </>
  );
}

export default CompanyVendorLocationMappings;
